// extracted by mini-css-extract-plugin
module.exports = {"root":"ChipTag_root__2VNtX","clickable":"ChipTag_clickable__1uTFF","innerLabel":"ChipTag_innerLabel__1b9jD","delete":"ChipTag_delete__O8GGb"};